import React, { useState } from 'react';
import { NavLink, Link } from 'react-router-dom';
import { FaBars, FaTimes } from 'react-icons/fa';

export default function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [hoveredItem, setHoveredItem] = useState(null);

  const navItems = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { name: 'Products', path: '/products' },
    { name: 'Brand Story', path: '/brand-story' },
    { name: 'FAQ', path: '/faq' },
    { name: 'Contact', path: '/contact' },
  ];

  const transitionStyles = {
    standard: { transition: 'all 0.3s ease' },
    elastic: { transition: 'width 0.3s ease' }
  };

  const fontStyle = {
    fontFamily: '"Playfair Display", serif'
  };

  return (
    <header style={{ backgroundColor: '#f8f9fa', padding: '0px 20px', position: 'sticky', top: 0, zIndex: 1000, ...fontStyle }}>
      <div className="container d-flex justify-content-between align-items-center">
        
        {/* Logo */}
        <Link to="/" style={{ textDecoration: 'none' }}>
          <img 
            src="/img/Logo-1.png" 
            alt="Spruha-Day'S Logo" 
            style={{ height: '70px', width: 'auto' }} // 👈 adjust size
          />
        </Link>

        {/* Desktop Menu */}
        <nav className="d-none d-md-flex gap-4">
          {navItems.map((item) => (
            <div
              key={item.name}
              style={{ position: 'relative', padding: '5px 0' }}
              onMouseEnter={() => setHoveredItem(item.name)}
              onMouseLeave={() => setHoveredItem(null)}
            >
              <NavLink
                to={item.path}
                style={({ isActive }) => ({
                  textDecoration: 'none',
                  fontSize: '1.1rem',
                  fontWeight: 500,
                  color: isActive
                    ? '#FFD700'
                    : hoveredItem === item.name
                    ? '#FFD700'
                    : '#333',
                  display: 'flex',
                  alignItems: 'center',
                  ...transitionStyles.standard,
                  transform: hoveredItem === item.name ? 'translateY(-2px)' : 'none',
                  ...fontStyle
                })}
              >
                {item.name}
              </NavLink>
              <div
                style={{
                  position: 'absolute',
                  bottom: 0,
                  left: 0,
                  width: hoveredItem === item.name ? '100%' : '0%',
                  height: '2px',
                  backgroundColor: '#FFD700',
                  ...transitionStyles.elastic
                }}
              ></div>
            </div>
          ))}
        </nav>

        {/* Mobile Menu Icon */}
        <div className="d-md-none">
          {mobileMenuOpen ? (
            <FaTimes
              size={24}
              style={{ cursor: 'pointer' }}
              onClick={() => setMobileMenuOpen(false)}
            />
          ) : (
            <FaBars
              size={24}
              style={{ cursor: 'pointer' }}
              onClick={() => setMobileMenuOpen(true)}
            />
          )}
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="d-md-none bg-light p-3" style={fontStyle}>
          {navItems.map((item) => (
            <NavLink
              key={item.name}
              to={item.path}
              onClick={() => setMobileMenuOpen(false)}
              style={({ isActive }) => ({
                display: 'flex',
                alignItems: 'center',
                padding: '10px 0',
                fontSize: '1.1rem',
                textDecoration: 'none',
                color: isActive ? '#FFD700' : '#333',
                ...fontStyle
              })}
            >
              {item.name}
            </NavLink>
          ))}
        </div>
      )}
    </header>
  );
}
